import { render, staticRenderFns } from "./VolunteerParticipation.vue?vue&type=template&id=21f3d24c&scoped=true&"
import script from "./VolunteerParticipation.vue?vue&type=script&lang=js&"
export * from "./VolunteerParticipation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f3d24c",
  null
  
)

export default component.exports